<div class="vflex-300">
  <h2>Buttons</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>
      import &#123; ButtonComponent &#125; from '&#64;spaces-ui/meadow/components/button';
    </code>
  </div>
  <h3>Default</h3>
  <section class="vflex-200 flex-no-stretch">
    <p>
      Default buttons are buttons without any additional classes. They are the most basic type of
      mdw-button.
    </p>
    <p>Default buttons should match Medium Secondary buttons.</p>
    <button class="mdw-button">Default</button>

    <button class="mdw-button" [icon]="icons.Home_Fill">Default</button>
    <button class="mdw-button" [icon]="icons.Home_Fill"></button>
  </section>

  <h3>Shapes</h3>
  <ng-template #shapesEx data-sample="shapesEx">
    <section class="vflex-300 flex-no-stretch">
      <button class="mdw-button mdw-primary">Default Shape</button>
      <button class="mdw-button mdw-primary pill-button">Pill Shape</button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="shapesEx" sampleName="shapesEx"></app-sample>

  <h3>Outline</h3>
  <ng-template #outlineEx data-sample="outlineEx">
    <section class="vflex-300 flex-no-stretch">
      <p>
        Outline buttons are transparent with a hairline border. Use them for a stack of equal-weight
        choices, like the ways to join on the call room landing page.
      </p>
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline x-large-button">Outline</button>
        <button class="mdw-button mdw-outline x-large-button" [icon]="icons.Home_Fill">
          Outline
        </button>
        <button class="mdw-button mdw-outline x-large-button" disabled>Disabled</button>
      </div>
      <button
        class="mdw-button mdw-outline x-large-button left-align fill-width"
        [icon]="icons.Home_Fill"
      >
        Full width, left aligned
      </button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="outlineEx" sampleName="outlineEx"></app-sample>

  <h3>X-Small</h3>
  <ng-template #buttonXSmall data-sample="buttonXSmall">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary x-small-button">Primary</button>
        <button class="mdw-button mdw-primary x-small-button pill-button">Primary</button>
        <button class="mdw-button mdw-primary x-small-button" [icon]="icons.Home_Fill"></button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary x-small-button">Secondary</button>
        <button class="mdw-button mdw-secondary x-small-button pill-button">Secondary</button>
        <button class="mdw-button mdw-secondary x-small-button" [icon]="icons.Home_Fill"></button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline x-small-button">Outline</button>
        <button class="mdw-button mdw-outline x-small-button pill-button">Outline</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary x-small-button">Tertiary</button>
        <button class="mdw-button mdw-tertiary x-small-button pill-button">Tertiary</button>
        <button class="mdw-button mdw-tertiary x-small-button" [icon]="icons.Home_Fill"></button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonXSmall" sampleName="buttonXSmall"></app-sample>

  <h3>Small</h3>
  <ng-template #buttonSmall data-sample="buttonSmall">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary small-button">Primary</button>
        <button class="mdw-button mdw-primary small-button pill-button">Primary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive small-button">Positive</button>
        <button class="mdw-button mdw-positive small-button pill-button">Positive</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary small-button">Secondary</button>
        <button class="mdw-button mdw-secondary small-button pill-button">Secondary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline small-button">Outline</button>
        <button class="mdw-button mdw-outline small-button pill-button">Outline</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary small-button">Tertiary</button>
        <button class="mdw-button mdw-tertiary small-button pill-button">Tertiary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger small-button">Danger!</button>
        <button class="mdw-button mdw-danger small-button pill-button">Danger!</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted small-button">Muted</button>
        <button class="mdw-button mdw-muted small-button pill-button">Muted</button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonSmall" sampleName="buttonSmall"></app-sample>
  <h3>Medium</h3>
  <ng-template #buttonMedium data-sample="buttonMedium">
    <section class="vflex-200 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary">Primary</button>
        <button class="mdw-button mdw-primary pill-button">Primary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive">Positive</button>
        <button class="mdw-button mdw-positive pill-button">Positive</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary">Secondary</button>
        <button class="mdw-button mdw-secondary pill-button">Secondary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline">Outline</button>
        <button class="mdw-button mdw-outline pill-button">Outline</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary">Tertiary</button>
        <button class="mdw-button mdw-tertiary pill-button">Tertiary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger">Danger!</button>
        <button class="mdw-button mdw-danger pill-button">Danger!</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted">Muted</button>
        <button class="mdw-button mdw-muted pill-button">Muted</button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonMedium" sampleName="buttonMedium"></app-sample>
  <h3>Large</h3>
  <ng-template #buttonLarge data-sample="buttonLarge">
    <section class="vflex-200 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary large-button">Primary</button>
        <button class="mdw-button mdw-primary large-button pill-button">Primary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive large-button">Positive</button>
        <button class="mdw-button mdw-positive large-button pill-button">Positive</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary large-button">Secondary</button>
        <button class="mdw-button mdw-secondary large-button pill-button">Secondary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline large-button">Outline</button>
        <button class="mdw-button mdw-outline large-button pill-button">Outline</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary large-button">Tertiary</button>
        <button class="mdw-button mdw-tertiary large-button pill-button">Tertiary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger large-button">Danger!</button>
        <button class="mdw-button mdw-danger large-button pill-button">Danger!</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted large-button">Muted</button>
        <button class="mdw-button mdw-muted large-button pill-button">Muted</button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonLarge" sampleName="buttonLarge"></app-sample>
  <h3>X-Large</h3>
  <ng-template #buttonXLarge data-sample="buttonXLarge">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary x-large-button">Primary</button>
        <button class="mdw-button mdw-primary x-large-button pill-button">Primary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive x-large-button">Positive</button>
        <button class="mdw-button mdw-positive x-large-button pill-button">Positive</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary x-large-button">Secondary</button>
        <button class="mdw-button mdw-secondary lx-arge-button pill-button">Secondary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline x-large-button">Outline</button>
        <button class="mdw-button mdw-outline x-large-button pill-button">Outline</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary x-large-button">Tertiary</button>
        <button class="mdw-button mdw-tertiary x-large-button pill-button">Tertiary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger x-large-button">Danger!</button>
        <button class="mdw-button mdw-danger x-large-button pill-button">Danger!</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted x-large-button">Muted</button>
        <button class="mdw-button mdw-muted x-large-button pill-button">Muted</button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonXLarge" sampleName="buttonXLarge"></app-sample>

  <h2>Buttons with Icons</h2>
  <h3>Small</h3>
  <ng-template #buttonWithIconSmall data-sample="buttonWithIconSmall">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary small-button" [icon]="icons.Home_Fill">
          Primary
        </button>
        <button class="mdw-button mdw-primary small-button pill-button" [icon]="icons.Home_Fill">
          Primary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive small-button" [icon]="icons.Home_Fill">
          Positive
        </button>
        <button class="mdw-button mdw-positive small-button pill-button" [icon]="icons.Home_Fill">
          Positive
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary small-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
        <button class="mdw-button mdw-secondary small-button pill-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary small-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
        <button class="mdw-button mdw-tertiary small-button pill-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger small-button" [icon]="icons.Home_Fill">Danger!</button>
        <button class="mdw-button mdw-danger small-button pill-button" [icon]="icons.Home_Fill">
          Danger!
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted small-button" [icon]="icons.Home_Fill">Muted</button>
        <button class="mdw-button mdw-muted small-button pill-button" [icon]="icons.Home_Fill">
          Muted
        </button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonWithIconSmall" sampleName="buttonWithIconSmall"></app-sample>

  <h3>Medium</h3>
  <ng-template #buttonWithIconMedium data-sample="buttonWithIconMedium">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary" [icon]="icons.Home_Fill">Primary</button>
        <button class="mdw-button mdw-primary pill-button" [icon]="icons.Home_Fill">Primary</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive" [icon]="icons.Home_Fill">Positive</button>
        <button class="mdw-button mdw-positive pill-button" [icon]="icons.Home_Fill">
          Positive
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary" [icon]="icons.Home_Fill">Secondary</button>
        <button class="mdw-button mdw-secondary pill-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary" [icon]="icons.Home_Fill">Tertiary</button>
        <button class="mdw-button mdw-tertiary pill-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger" [icon]="icons.Home_Fill">Danger!</button>
        <button class="mdw-button mdw-danger pill-button" [icon]="icons.Home_Fill">Danger!</button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted" [icon]="icons.Home_Fill">Muted</button>
        <button class="mdw-button mdw-muted pill-button" [icon]="icons.Home_Fill">Muted</button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonWithIconMedium" sampleName="buttonWithIconMedium"></app-sample>

  <h3>Large</h3>
  <ng-template #buttonWithIconLarge data-sample="buttonWithIconLarge">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary large-button" [icon]="icons.Home_Fill">
          Primary
        </button>
        <button class="mdw-button mdw-primary large-button pill-button" [icon]="icons.Home_Fill">
          Primary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive large-button" [icon]="icons.Home_Fill">
          Positive
        </button>
        <button class="mdw-button mdw-positive large-button pill-button" [icon]="icons.Home_Fill">
          Positive
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary large-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
        <button class="mdw-button mdw-secondary large-button pill-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary large-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
        <button class="mdw-button mdw-tertiary large-button pill-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger large-button" [icon]="icons.Home_Fill">Danger!</button>
        <button class="mdw-button mdw-danger large-button pill-button" [icon]="icons.Home_Fill">
          Danger!
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted large-button" [icon]="icons.Home_Fill">Muted</button>
        <button class="mdw-button mdw-muted large-button pill-button" [icon]="icons.Home_Fill">
          Muted
        </button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonWithIconLarge" sampleName="buttonWithIconLarge"></app-sample>

  <h3>X-Large</h3>
  <ng-template #buttonWithIconXLarge data-sample="buttonWithIconXLarge">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-primary x-large-button" [icon]="icons.Home_Fill">
          Primary
        </button>
        <button class="mdw-button mdw-primary x-large-button pill-button" [icon]="icons.Home_Fill">
          Primary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-positive x-large-button" [icon]="icons.Home_Fill">
          Positive
        </button>
        <button class="mdw-button mdw-positive x-large-button pill-button" [icon]="icons.Home_Fill">
          Positive
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-secondary x-large-button" [icon]="icons.Home_Fill">
          Secondary
        </button>
        <button
          class="mdw-button mdw-secondary x-large-button pill-button"
          [icon]="icons.Home_Fill"
        >
          Secondary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-outline x-large-button" [icon]="icons.Home_Fill">
          Outline
        </button>
        <button class="mdw-button mdw-outline x-large-button pill-button" [icon]="icons.Home_Fill">
          Outline
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-tertiary x-large-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
        <button class="mdw-button mdw-tertiary x-large-button pill-button" [icon]="icons.Home_Fill">
          Tertiary
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-danger x-large-button" [icon]="icons.Home_Fill">
          Danger!
        </button>
        <button class="mdw-button mdw-danger x-large-button pill-button" [icon]="icons.Home_Fill">
          Danger!
        </button>
      </div>

      <div class="hflex-300 flex-align-items-center">
        <button class="mdw-button mdw-muted x-large-button" [icon]="icons.Home_Fill">Muted</button>
        <button class="mdw-button mdw-muted x-large-button pill-button" [icon]="icons.Home_Fill">
          Muted
        </button>
      </div>
    </section>
  </ng-template>
  <app-sample [sampleContent]="buttonWithIconXLarge" sampleName="buttonWithIconXLarge"></app-sample>

  <h2>Icon Buttons</h2>
  <ng-template #iconButton data-sample="iconButton">
    <section class="vflex-300 flex-no-stretch">
      <button class="mdw-button mdw-primary small-button" [icon]="icons.Apple_Fill"></button>
      <button class="mdw-button mdw-secondary medium-button" [icon]="icons.Apple_Fill"></button>
      <button class="mdw-button mdw-positive large-button" [icon]="icons.Apple_Fill"></button>
      <button class="mdw-button mdw-danger x-large-button" [icon]="icons.Apple_Fill"></button>
      <button class="mdw-button mdw-tertiary color-preset-17" [icon]="icons.Apple_Fill"></button>
      <button class="mdw-button mdw-muted large-button" [icon]="icons.Apple_Fill"></button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="iconButton" sampleName="iconButton"></app-sample>

  <h2>Button with Dynamic Text</h2>
  <p>
    This is just a test scenario to make sure the button component properly displays dynamic text.
  </p>
  <section class="vflex-200 flex-no-stretch">
    <button class="mdw-button">
      {{ 'Dynamic Text' }}
    </button>
  </section>

  <h2>Dropdown/Menu/Flyout trigger buttons</h2>
  <p>
    The button component has an optional
    <code>showDownArrow</code>
    property to be used when the button acts as a trigger for a menu/flyout/dropdown, and the
    designer wants to show affordance to this.
  </p>
  <ng-template #dropDownButton data-sample="dropDownButton">
    <section class="vflex-300 flex-no-stretch">
      <button class="mdw-button mdw-primary" [showDownArrow]="true">Select space</button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="dropDownButton" sampleName="dropDownButton"></app-sample>

  <h2>Split buttons</h2>
  <p>
    <code>mdw-split-button</code>
    joins a main action to a caret that opens a menu. Supply the menu as an
    <code>ng-template</code>
    containing a
    <code>cdkMenu</code>
    via the required
    <code>menu</code>
    input. The main half emits
    <code>buttonClick</code>
    ; the caret only opens the menu.
  </p>
  <div role="list" class="vflex-100">
    <div role="listitem">
      <code>menu</code>
      (required) — the
      <code>TemplateRef</code>
      rendered as the menu.
    </div>
    <div role="listitem">
      <code>menuLabel</code>
      — accessible name for the caret (default
      <code>More options</code>
      ). Describe what the menu holds, e.g. "More send options".
    </div>
    <div role="listitem">
      <code>menuPosition</code>
      — optional CDK
      <code>ConnectedPosition[]</code>
      (default: below the control, end-aligned).
    </div>
    <div role="listitem">
      <code>disabled</code>
      — disables both halves.
    </div>
    <div role="listitem">
      <code>type</code>
      —
      <code>'Button'</code>
      (default) or
      <code>'Submit'</code>
      ; applies to the main half only.
    </div>
    <div role="listitem">
      Variant, size and shape use the same classes as
      <code>mdw-button</code>
      (
      <code>mdw-primary</code>
      ,
      <code>large-button</code>
      ,
      <code>pill-button</code>
      , …), plus
      <code>mdw-outline</code>
      .
    </div>
  </div>
  <ng-template #splitButton data-sample="splitButton">
    <section class="vflex-300 flex-no-stretch">
      <mdw-split-button
        class="mdw-primary"
        [menu]="sendMenu"
        menuLabel="More send options"
        (buttonClick)="sendSplit()"
      >
        Send
      </mdw-split-button>
      <p>Sent {{ splitClicks() }} time(s)</p>
    </section>
    <ng-template #sendMenu>
      <menu
        class="pad-100 surface-floating border-radius-100"
        cdkMenu
        animate.enter="menu-enter"
        animate.leave="menu-leave"
      >
        <ul>
          <li cdkMenuItem [icon]="icons.Plus">Schedule send</li>
          <li cdkMenuItem [icon]="icons.Home_Fill">Send to home</li>
        </ul>
      </menu>
    </ng-template>
  </ng-template>
  <app-sample [sampleContent]="splitButton" sampleName="splitButton"></app-sample>

  <h3>Split button variants</h3>
  <ng-template #splitButtonVariants data-sample="splitButtonVariants">
    <section class="hflex-300 flex-wrap flex-align-items-center">
      <mdw-split-button class="mdw-primary" [menu]="variantMenu">Primary</mdw-split-button>
      <mdw-split-button class="mdw-secondary" [menu]="variantMenu">Secondary</mdw-split-button>
      <mdw-split-button class="mdw-tertiary" [menu]="variantMenu">Tertiary</mdw-split-button>
      <mdw-split-button class="mdw-danger" [menu]="variantMenu">Danger</mdw-split-button>
      <mdw-split-button class="mdw-muted" [menu]="variantMenu">Muted</mdw-split-button>
      <mdw-split-button class="mdw-positive" [menu]="variantMenu">Positive</mdw-split-button>
      <mdw-split-button class="mdw-outline" [menu]="variantMenu">Outline</mdw-split-button>
      <div class="surface-flat-inverse pad-200 border-radius-100">
        <mdw-split-button class="mdw-tertiary-inverse" [menu]="variantMenu">
          Tertiary inverse
        </mdw-split-button>
      </div>
    </section>
    <ng-template #variantMenu>
      <menu class="pad-100 surface-floating border-radius-100" cdkMenu>
        <ul>
          <li cdkMenuItem>Option one</li>
          <li cdkMenuItem>Option two</li>
        </ul>
      </menu>
    </ng-template>
  </ng-template>
  <app-sample
    [sampleContent]="splitButtonVariants"
    sampleName="splitButtonVariants"
    [stackVertical]="true"
  ></app-sample>

  <h3>Split button sizes and shapes</h3>
  <ng-template #splitButtonSizes data-sample="splitButtonSizes">
    <section class="vflex-300 flex-no-stretch">
      <div class="hflex-300 flex-align-items-center">
        <mdw-split-button class="mdw-primary small-button" [menu]="sizeMenu">
          Small
        </mdw-split-button>
        <mdw-split-button class="mdw-primary medium-button" [menu]="sizeMenu">
          Medium
        </mdw-split-button>
        <mdw-split-button class="mdw-primary large-button" [menu]="sizeMenu">
          Large
        </mdw-split-button>
        <mdw-split-button class="mdw-primary x-large-button" [menu]="sizeMenu">
          Extra large
        </mdw-split-button>
      </div>
      <div class="hflex-300 flex-align-items-center">
        <mdw-split-button class="mdw-secondary small-button pill-button" [menu]="sizeMenu">
          Small
        </mdw-split-button>
        <mdw-split-button class="mdw-secondary medium-button pill-button" [menu]="sizeMenu">
          Medium
        </mdw-split-button>
        <mdw-split-button class="mdw-secondary large-button pill-button" [menu]="sizeMenu">
          Large
        </mdw-split-button>
        <mdw-split-button class="mdw-secondary x-large-button pill-button" [menu]="sizeMenu">
          Extra large
        </mdw-split-button>
      </div>
    </section>
    <ng-template #sizeMenu>
      <menu class="pad-100 surface-floating border-radius-100" cdkMenu>
        <ul>
          <li cdkMenuItem>Option one</li>
          <li cdkMenuItem>Option two</li>
        </ul>
      </menu>
    </ng-template>
  </ng-template>
  <app-sample
    [sampleContent]="splitButtonSizes"
    sampleName="splitButtonSizes"
    [stackVertical]="true"
  ></app-sample>

  <h3>Disabled split button</h3>
  <ng-template #splitButtonDisabled data-sample="splitButtonDisabled">
    <section class="hflex-300 flex-no-stretch">
      <mdw-split-button class="mdw-primary" [menu]="disabledMenu" [disabled]="true">
        Send
      </mdw-split-button>
    </section>
    <ng-template #disabledMenu>
      <menu class="pad-100 surface-floating border-radius-100" cdkMenu>
        <ul>
          <li cdkMenuItem>Option one</li>
        </ul>
      </menu>
    </ng-template>
  </ng-template>
  <app-sample [sampleContent]="splitButtonDisabled" sampleName="splitButtonDisabled"></app-sample>

  <h2>Submit buttons</h2>
  <p>
    By default, the mdw-button component is a type="button". If you need a submit button, you can
    set the type attribute to `submit`.
  </p>
  <ng-template #submitButton data-sample="submitButton">
    <section class="vflex-300 flex-no-stretch">
      <button class="mdw-button mdw-primary" type="submit">Submit</button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="submitButton" sampleName="submitButton"></app-sample>

  <h2>Button Groups</h2>
  <p>
    Button groups are used to group buttons together. Each button size has its own spacing
    defintion.
  </p>
  <ng-template #buttonGroups data-sample="buttonGroups">
    <div class="vflex-200">
      <div class="button-group">
        <button class="mdw-button mdw-secondary">Secondary</button>
        <button class="mdw-button mdw-primary">Primary</button>
      </div>
      <div class="button-group-small">
        <button class="mdw-button mdw-secondary small-button">Secondary</button>
        <button class="mdw-button mdw-primary small-button">Primary</button>
      </div>
      <div class="button-group-medium">
        <button class="mdw-button mdw-secondary medium-button">Secondary</button>
        <button class="mdw-button mdw-primary medium-button">Primary</button>
      </div>
      <div class="button-group-large">
        <button class="mdw-button mdw-secondary large-button">Secondary</button>
        <button class="mdw-button mdw-primary large-button">Primary</button>
      </div>
      <div class="button-group-x-large">
        <button class="mdw-button mdw-secondary x-large-button">Secondary</button>
        <button class="mdw-button mdw-primary x-large-button">Primary</button>
      </div>
    </div>
  </ng-template>
  <app-sample [sampleContent]="buttonGroups" sampleName="buttonGroups"></app-sample>

  <h2>CSS custom properties</h2>
  <p>
    mdw-button exposes consumer-facing custom properties so common per-instance tweaks don't require
    piercing the component with
    <code>::ng-deep</code>
    . Set them on the host button (or any ancestor) — each falls back to the variant's normal
    styling when unset.
  </p>
  <div role="list" class="vflex-100">
    <div role="listitem">
      <code>--mdw-button-icon-color</code>
      — recolors the icon glyph (default: the variant's icon color). The
      <code>color</code>
      /
      <code>iconPresetColorNumber</code>
      input classes still win by design.
    </div>
    <div role="listitem">
      <code>--mdw-button-overlay-bg</code>
      — replaces the hover/pressed overlay tint; set
      <code>transparent</code>
      to suppress it when the button provides its own interaction feedback.
    </div>
    <div role="listitem">
      <code>--mdw-button-icon-transform</code>
      — transforms the icon glyph (default:
      <code>none</code>
      ); changes animate with a built-in 0.2s transition.
    </div>
  </div>
  <ng-template #customProperties data-sample="customProperties">
    <section class="hflex-300 flex-no-stretch flex-align-items-center">
      <button
        class="mdw-button mdw-muted"
        [icon]="icons.Home_Fill"
        style="--mdw-button-icon-color: var(--color-icon-blue)"
      >
        Custom icon color
      </button>
      <button
        class="mdw-button mdw-muted"
        [icon]="icons.Home_Fill"
        style="--mdw-button-overlay-bg: transparent"
      >
        No hover tint
      </button>
      <button
        class="mdw-button mdw-muted small-button"
        [icon]="icons.Plus"
        aria-label="Toggle icon rotation"
        [style.--mdw-button-icon-transform]="rotated() ? 'rotate(45deg)' : 'rotate(0deg)'"
        (click)="toggleRotated()"
      ></button>
    </section>
  </ng-template>
  <app-sample [sampleContent]="customProperties" sampleName="customProperties"></app-sample>
</div>
